import { gql } from '@apollo/client';

export const updateCampaign = gql`
    mutation updateCampaign($updateCampaignId: ID!, $input: UpdateCampaignInput!) {
        updateCampaign(id: $updateCampaignId, input: $input) {
            id
        }
    }
`;
